import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import axios from 'axios';
import { apiUrl } from '../../apiUrl/ApiUrl';

export default function ExchangeRateManage() {
    const [exchangeRates, setExchangeRates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editData, setEditData] = useState(null);
    const [newRate, setNewRate] = useState('');
    

    // 取得匯率資料
    useEffect(() => {
        setLoading(true);
        const fetchExchangeRates = async () => {
            try {
                const response = await axios.get(`${apiUrl}/ReceviableAccount/ReExchangeRate`);
                setExchangeRates(response.data);
            } catch (error) {
                console.error('取得匯率失敗:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchExchangeRates();
    }, []);

    // 更新匯率的函式
    const handleUpdate = async (rate) => {
        setLoading(true);
        try {
            console.log("更新匯率資料:", {
                id: rate.id,
                exchangerate: parseFloat(newRate),
            });
            // 傳送更新請求到後端，根據記錄的 id 更新匯率
            const response = await axios.post(`${apiUrl}/ReceviableAccount/updateExchangeRate`, {
                id: rate.id,
                exchangerate: parseFloat(newRate),
            });
    
            if (response.status === 200) {
                alert('匯率更新成功');
                // 更新本地狀態以反映新的匯率與更新時間
                setExchangeRates((prevRates) =>
                    prevRates.map((r) =>
                        r.id === rate.id
                            ? {
                                  ...r,
                                  exchangerate: parseFloat(newRate),
                                  lastupdated: new Date().toISOString(), // 更新最後更新時間
                              }
                            : r
                    )
                );
                setEditData(null);
            }
        } catch (error) {
            console.error('更新匯率失敗:', error);
            alert('更新匯率失敗，請稍後再試');
        }finally{
            setLoading(false);
        }
    };
    

    return (
        <>
        <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        <div>
            <h2>匯率管理</h2>
            {loading ? (
                <p>讀取中...</p>
            ) : (
                <table className="table">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>幣別</th>
                            <th>匯率</th>
                            <th>最後更新</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exchangeRates.map((rate, index) => (
                            <tr key={index}>
                                <td>{rate.id}</td>
                                <td>{rate.name}</td>
                                <td>
                                    {editData &&
                                    editData.curr === rate.curr &&
                                    editData.name === rate.name ? (
                                        <input
                                            type="text"
                                            value={newRate}
                                            onChange={(e) => setNewRate(e.target.value)}
                                        />
                                    ) : (
                                        rate.exchangerate
                                    )}
                                </td>
                                <td>{new Date(rate.lastupdated).toLocaleString()}</td>
                                <td>
                                    {editData &&
                                    editData.curr === rate.curr &&
                                    editData.name === rate.name ? (
                                        <button
                                            onClick={() =>
                                                handleUpdate(rate)
                                            }
                                            className="btn btn-success"
                                        >
                                            儲存
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                setEditData(rate);
                                                setNewRate(rate.exchangerate.toString());
                                            }}
                                            className="btn btn-primary"
                                        >
                                            編輯
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
        </>
    );
}
